// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__fyX-a","inner":"HeaderSimple_inner__-wTYi","link":"HeaderSimple_link__vRAJm","inputSearch":"HeaderSimple_inputSearch__ZU6NG"};